























































import { defineComponent, PropType, vue3Model } from '~/utils/nuxt3-migration'
import { Icon } from '~/models/icons/types'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    bodyText: {
      type: String,
      required: false,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    containerClass: { type: [String, Array, Object], default: null },
    okIcon: {
      type: Object,
      default: () => null
    },
    cancelText: {
      type: String,
      default: ''
    },
    cancelIcon: {
      type: Object,
      default: () => null
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    okVariant: {
      type: String,
      required: false,
      default: 'primary'
    },
    okOutline: {
      type: Boolean,
      required: false,
      default: false
    },
    cancelVariant: {
      type: String,
      required: false,
      default: 'link'
    },
    cancelOutline: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    icon: {
      type: Object as PropType<Icon>,
      required: false,
      default: null
    },
    iconClasses: {
      type: String,
      required: false,
      default: ''
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false
    },
    disableAnimations: {
      type: Boolean,
      default: false
    },
    hideHeaderClose: {
      type: Boolean,
      default: false
    },
    cancelCallback: {
      type: Function,
      required: false,
      default: null
    },
    displayOnlyLastModal: {
      type: Boolean,
      default: true
    },
    hash: { type: String, default: undefined }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(value: boolean) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    }
  },
  methods: {
    onCancel() {
      if (this.cancelCallback) {
        this.cancelCallback()
        return
      }
      this.$emit('cancel')
    },
    handleHide() {
      if (this.cancelCallback) {
        this.cancelCallback()
        return
      }
      this.$emit('cancel')
      this.$emit('hide')
    }
  }
})
